/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MarkProgramAsFavoriteInput = {|
  programId: string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type markProgramAsFavoriteMutationVariables = {|
  input: MarkProgramAsFavoriteInput
|};
export type markProgramAsFavoriteMutationResponse = {|
  +markProgramAsFavorite: ?{|
    +program: ?{|
      +node: ?{|
        +id: string,
        +userRelationTypes: ?$ReadOnlyArray<?string>,
      |}
    |}
  |}
|};
export type markProgramAsFavoriteMutation = {|
  variables: markProgramAsFavoriteMutationVariables,
  response: markProgramAsFavoriteMutationResponse,
|};
*/


/*
mutation markProgramAsFavoriteMutation(
  $input: MarkProgramAsFavoriteInput!
) {
  markProgramAsFavorite(input: $input) {
    program {
      node {
        id
        userRelationTypes
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "MarkProgramAsFavoriteInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkProgramAsFavoritePayload",
    "kind": "LinkedField",
    "name": "markProgramAsFavorite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectServiceProgramTypeEdge",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgramType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userRelationTypes",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "markProgramAsFavoriteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "markProgramAsFavoriteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "markProgramAsFavoriteMutation",
    "operationKind": "mutation",
    "text": "mutation markProgramAsFavoriteMutation(\n  $input: MarkProgramAsFavoriteInput!\n) {\n  markProgramAsFavorite(input: $input) {\n    program {\n      node {\n        id\n        userRelationTypes\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '10f9ad2de089c97486682d24001f3dff';

module.exports = node;
